const PASSWORD_RESET_PATH = /^\/change-password\/[A-Za-z0-9-]+$/;

export function passwordResetPathFromHash(hash: string): string | null {
  if (!hash.startsWith('#/')) return null;

  const path = hash.slice(1);
  return PASSWORD_RESET_PATH.test(path) ? path : null;
}
